
import React from 'react';

const WelcomeHeader = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold tracking-tight">Welcome back, Admin</h1>
      <p className="text-muted-foreground">
        Here's an overview of your clinic's activity
      </p>
    </div>
  );
};

export default WelcomeHeader;
